module.exports = __webpack_public_path__ + "media/images/lp/sv/img/pc/header-bccdd6febba119c161f3bcedf9e0e703.jpg";